"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const pulse_components_1 = require("@pcs/pulse-components");
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const OptionsComponent = (props) => {
    const { data, isLoading, isLoadingComponent, handleChangeOption } = props;
    if (!data) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const handleClick = () => {
        if ((0, lodash_1.isFunction)(handleChangeOption))
            handleChangeOption(data);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isLoading && !isLoadingComponent ? (react_1.default.createElement(material_1.Skeleton, { className: styles_modules_less_1.default.skeletonOption })) : (react_1.default.createElement("div", { className: styles_modules_less_1.default.notifyOptions, key: data === null || data === void 0 ? void 0 : data.label },
        react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default.notifyOptions__btn], label: data.label, onClick: handleClick })))));
};
exports.default = OptionsComponent;
